export default __webpack_public_path__ + "static/media/raccoon_1.198cb87f.png";